import UpperNavBar from "components/board/UpperNavBar"
import { formatMessage } from "i18n/CurrentLocale"
import rawstrings from "string-translations/rawstrings"

// LEGACY

export const Background = (props: any) => (
    <div id="registration-container">
        <div className='grid-viewport'>
            <UpperNavBar
                backgroundColor="white"
                logoRedirecsTo={formatMessage(rawstrings.parkdWebsiteHomeUrl)}
                openInNewTab
                showSupportPhoneNumber
            />
        </div>
        <div id="registration-screen">
            {props.children}
        </div>
    </div>
)
